export const mutationUpdateUserNames = `mutation UpdateUserNames(
  $userid: Int!
  $username: String
  $alias: String
  $fullname: String
) {
  UpdateUserProfile(
    userData: {
      userid: $userid
      username: $username
      alias: $alias
      fullname: $fullname
    }
  ) {
    user {
      uid
      username
      alias
      fullname
    }
  }
}`;
